var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('h2',[_vm._v("Review")]),_c('XTable',{attrs:{"x-content":_vm.content,"x-columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }